// extracted by mini-css-extract-plugin
module.exports = {"instrument-title":"InstrumentHeader_instrument-title__q2xMq","instrument-price":"InstrumentHeader_instrument-price__CL7oI"};